import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {StackParamList} from '../../stacks';
import {SubClientProvider} from '../../../context/sub-client';
import {NotificationsScreen, ProfileScreen} from '../../../screens/internals';
import {ProofPaymentScreen} from '../../../screens/internals/commons/proof-payment';
import {DashboardScreen} from '../../../screens/internals/sub-client/enchanced/dashboard';
import {
  HistoryDetail,
  HistoryList,
} from '../../../screens/internals/commons/history';
import {
  ProofSuccessScreen,
  RemoveSuccessScreen,
  SendSuccessScreen,
} from '../../../screens/internals/commons/success';
import UnpaidedBillListScreen from '../../../screens/internals/sub-client/enchanced/unpaid-invoices/list/UnpaidedList';
import InvoiceFeesScreen from '../../../screens/internals/sub-client/enchanced/unpaid-invoices/fees/InvoiceFees';
import {FeePaymentOptionScreen} from '../../../screens/internals/sub-client/enchanced/fee-payment-options';
import {FeePaymentProofScreen} from '../../../screens/internals/sub-client/enchanced/payment-proof';
import {PaymentC2pFormScreen} from '../../../screens/internals/sub-client/enchanced/payment-c2p-form';
import {C2pPaymentSuccessScreen} from '../../../screens/internals/sub-client/enchanced/success/c2p-payment-success';
import {FeePaymentProofSuccessScreen} from '../../../screens/internals/sub-client/enchanced/success/fee-payment-proof-success';
import FeePaymentDetailScreen from '../../../screens/internals/sub-client/enchanced/fee-payment-detail';
import {PaymentC2PConfirmationScreen} from '../../../screens/internals/sub-client/enchanced/payment-c2p-confirmation';
import {PaymentCreditCardFormScreen} from '../../../screens/internals/sub-client/enchanced/payment-credit-card-form';
import {PaymentCreditCardSuccessScreen} from '../../../screens/internals/sub-client/enchanced/success/credit-card-payment-success';

const Stack = createNativeStackNavigator<StackParamList>();

type StackGroupAnonymousProps = {
  groupOptions: {
    screenOptions: {headerTransparent: boolean; headerTitle: string};
  };
};

export const NavigatorSubClient = ({
  groupOptions,
}: StackGroupAnonymousProps) => {
  return (
    <SubClientProvider>
      <Stack.Navigator
        initialRouteName={'Dashboard'}
        screenOptions={{headerShown: false}}>
        <Stack.Group {...groupOptions}>
          <Stack.Screen name="Dashboard" component={DashboardScreen} />
          <Stack.Screen name="Profile" component={ProfileScreen} />
          <Stack.Screen name="Notifications" component={NotificationsScreen} />
          <Stack.Screen name="ProofPayment" component={ProofPaymentScreen} />
          <Stack.Screen
            name="InvoiceFeesScreen"
            component={InvoiceFeesScreen}
          />
          <Stack.Screen
            name="UnpaidedBillListScreen"
            component={UnpaidedBillListScreen}
          />
          <Stack.Screen name="HistoryDetail" component={HistoryDetail} />
          <Stack.Screen name="HistoryList" component={HistoryList} />
          <Stack.Screen name="ProofSuccess" component={ProofSuccessScreen} />
          <Stack.Screen name="SendSuccess" component={SendSuccessScreen} />
          <Stack.Screen name="RemoveSuccess" component={RemoveSuccessScreen} />
          <Stack.Screen
            name="FeePaymentOptionScreen"
            component={FeePaymentOptionScreen}
          />
          <Stack.Screen
            name="FeePaymentDetailScreen"
            component={FeePaymentDetailScreen}
          />
          <Stack.Screen
            name="FeePaymentProofScreen"
            component={FeePaymentProofScreen}
          />
          <Stack.Screen
            name="PaymentC2pConfirmationScreen"
            component={PaymentC2PConfirmationScreen}
          />
          <Stack.Screen
            name="PaymentC2pFormScreen"
            component={PaymentC2pFormScreen}
          />
          <Stack.Screen
            name="PaymentCreditCardFormScreen"
            component={PaymentCreditCardFormScreen}
          />
          <Stack.Screen
            name="PaymentCreditCardSuccessScreen"
            component={PaymentCreditCardSuccessScreen}
          />
          <Stack.Screen
            name="C2pPaymentSuccessScreen"
            component={C2pPaymentSuccessScreen}
          />
          <Stack.Screen
            name="FeePaymentProofSuccessScreen"
            component={FeePaymentProofSuccessScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </SubClientProvider>
  );
};
